// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3v471","noInteraction":"EventWrapper_noInteraction__NfJ9H"};